export default function asyncToken(instance, getToken) {
    instance.interceptors.request.use(function (config) {
        return getToken().then((accessToken) => {
            config.headers.set('Authorization', `Bearer ${accessToken}`);
            return config;
        });
    });
}
